module.exports = __webpack_public_path__ + "static/img/user1.d800f3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v1/user1.png
// module id = GoNh
// module chunks = 0